import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PasswordResetComponent } from './password-reset/password-reset.component';
import { PasswordResetService } from './service/password-reset.service';
import { PasswordResetUrlService } from './service/password-reset-url.service';
import { FormsModule } from '@angular/forms';
import { PasswordResetGaurd } from './guard/password-reset.gaurd';

@NgModule({
	imports: [CommonModule, FormsModule],
	providers: [PasswordResetService, PasswordResetUrlService, PasswordResetGaurd],
	declarations: [PasswordResetComponent],
	exports: [PasswordResetComponent]
})
export class PasswordResetModule {}
